/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import axios from '../../utils/axios';
import { getCookieOptions } from '../../utils/utils';
import Cookies from 'universal-cookie';
import { getLegacyAuthToken } from '../../auth/session';

export const RootContext = React.createContext();

export default ({ children, value }) => {

  const cookies = new Cookies();

  const prevAuth = getLegacyAuthToken();
  const [isAdminMenuOpen, setIsAdminMenuOpen] = useState(true); // controls left menu in admin section
  const [viewProperties, setProperties] = useState(false);
  const [isAdmin, setisAdmin] = useState(false);
  const [authToken, setAuthToken] = useState(prevAuth);
  const [authSource, setAuthSource] = useState(prevAuth ? 'legacy' : null);
  const [currentUser, setCurrentUser] = useState(null);
  const [propertyList, setPropertyList] = useState([]);
  const [viewerProfile, setViewerProfile] = useState(null);
  const [assetSchema, setAssetSchema] = useState(null);
  const [sectionSchema, setSectionSchema] = useState({});
  const [mobileView, setMobileView] = useState(window.innerWidth <= 768);
  const [smallMobileView, setSmallMobileView] = useState(window.innerWidth <= 576);
  const [xLargeView, setXLargeView] = useState(window.innerWidth >= 1200);
  const [largeView, setLargeView] = useState(window.innerWidth >= 992);

  useEffect(() => {
    if (!authToken) {
      const opts = getCookieOptions();
      cookies.remove('auth', {path: opts.path, domain: opts.domain});
    }
  }, [authToken]);

  useEffect(() => {
    const handleResize = () => {
      setSmallMobileView(window.innerWidth <= 576);
      setLargeView(window.innerWidth >= 992);
      setXLargeView(window.innerWidth >= 1200)
      setMobileView(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return _ => window.removeEventListener('resize', handleResize);
  });

  // load asset schema when the application loads
  useEffect(() => {
    const retrieveAssetSchema = async () => {
      const result = await axios.get(`/public/space-profile-assets/schema`);
      if (result.status === 200) {
        setAssetSchema(result.data.default);
        setSectionSchema(result.data.sectionSchema);
      }
    }

    retrieveAssetSchema();
  }, []);

  const defaultContext = {
    currentUser,
    setCurrentUser,
    isAdminMenuOpen,
    setIsAdminMenuOpen,
    authToken,
    setAuthToken,
    authSource,
    setAuthSource,
    viewProperties,
    setProperties,
    isAdmin,
    setisAdmin,
    propertyList,
    setPropertyList,
    viewerProfile,
    setViewerProfile,
    assetSchema,
    sectionSchema,
    mobileView,
    smallMobileView,
    xLargeView,
    largeView
  };

  return (
    <RootContext.Provider value={value || defaultContext}>
      {children}
    </RootContext.Provider>
  );
};
